module.exports = __webpack_public_path__ + "img/logo-cyberdigma.9e9b3b2d.png";